import React from 'react';
import {get} from 'lodash';
import className from 'classnames';
import * as queryString from 'query-string'

class TableHeader extends React.Component {
  static propTypes = {
  };

  static defaultProps = {
  };

  state = {
  };

  render = () => {
    const sortKey = get(this.props, 'header.sortKey')
    const sortKeyCurrent = get(queryString.parse(get(window, 'location.search')), 'order_by')
    const order = get(queryString.parse(get(window, 'location.search')), 'order')
    const parsed = {
      ...queryString.parse(get(window, 'location.search')),
      'order': sortKey != sortKeyCurrent ? 'desc' : (order == 'desc' ? 'asc' : 'desc'),
      'order_by': sortKey,
    }

    return (
      <a
        className={className('Table__col', get(this.props, 'header.className'), {
          'Table__col--th': true,
          'Table__col--sort': sortKey,
          'Table__col--sort--asc': sortKey == sortKeyCurrent && order == 'asc',
          'Table__col--sort--desc': sortKey == sortKeyCurrent && order == 'desc',
        })}
        href={  // If a user change sorting column then always sort desc, if not then change sorting direction.
          sortKey ?
            `?${queryString.stringify(parsed)}`
          :
            null
        }
      >
        <span
          className={className({
            'Table__col--sort__span': sortKey,
          })}
          dangerouslySetInnerHTML={{__html: get(this.props, 'header.label')}}
        />
      </a>
    )
  }
}

export default TableHeader;
